@switch (variant()) {
  @case ('stacked') {
    <textarea
      ngpTextarea
      #textareaEl
      rows="1"
      [value]="value()"
      [placeholder]="placeholder()"
      (input)="onValueInput($event); updateMultiline()"
      (keydown)="onTextareaKeydown($event)"
      joii-text
      [size]="4"
      [color]="focused() ? 'form-text-active' : 'placeholder'"
    ></textarea>
    <div class="input-llm-stacked-actions">
      <div class="input-llm-stacked-actions stacked-actions-start">
        <ng-content select="[slot=prefix]" />
      </div>
      <div class="input-llm-stacked-actions stacked-actions-end">
        <ng-content select="[slot=suffix]" />
        <button
          joii-button
          [iconOnly]="true"
          [icon]="sendIcon"
          [disabled]="disabled()"
          (click)="onSendButtonClick()"
        ></button>
      </div>
    </div>
  }
  @default {
    <ng-content select="[slot=prefix-simple]" />
    <textarea
      ngpTextarea
      #textareaEl
      rows="1"
      [value]="value()"
      [placeholder]="placeholder()"
      (input)="onValueInput($event); updateMultiline()"
      (keydown)="onTextareaKeydown($event)"
      joii-text
      [size]="4"
      [color]="focused() ? 'form-text-active' : 'placeholder'"
    ></textarea>
    <ng-content select="[slot=suffix-simple]" />
    <button
      joii-button
      [iconOnly]="true"
      [icon]="sendIcon"
      [disabled]="disabled()"
      (click)="onSendButtonClick()"
    ></button>
  }
}
